import { render, staticRenderFns } from "./AddSupport.vue?vue&type=template&id=a2c7c300&"
import script from "./AddSupport.vue?vue&type=script&lang=js&"
export * from "./AddSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports